import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useRef } from 'react';
import { PageHeader } from '@ui/layout/Layout/components';
import SSearchInput from '@ui/components/common/SSearchInput';
import { FiltersDiscardButton } from '@ui/components/common/buttons';
import SystemsDataGrid from './components/SystemsDataGrid';
import { SystemDialog } from '@ui/components/Dialogs';
import { systemApi } from '@application/api/endpoints/system-api';
import { convertToLocalTimezone } from '@application/utilities/date-time-formater';
const Systems = () => {
    const [isFilterEnabled, setIsFilterEnabled] = useState(false);
    const [systemDetails, setSystemDetails] = useState();
    const [systemDialog, setSystemDialog] = useState({
        show: false,
        variant: '',
        title: ''
    });
    const [systemQuery, setSystemQuery] = useState({
        pageNumber: 1,
        pageSize: 10
    });
    const initialFilters = {
        search: '',
        systemName: '',
        systemType: '',
        lastLocation: '',
        lastInfoReceivedFilter: '',
        asset: '',
        description: '',
        isActive: ''
    };
    const initialQueryState = {
        searchTerm: '',
        systemNameFilter: '',
        systemTypeFilter: '',
        description: '',
        locationFilter: '',
        lastInfoReceivedFilter: null,
        assetFilter: '',
        statusFilter: undefined // or false if you want to default it
    };
    const [filters, setFilters] = useState(initialFilters);
    // Track mount state for fetch deduplication
    const isInitialMountRef = useRef(true);
    const prevQueryRef = useRef(null);
    const handleCloseSystemDialog = () => {
        setSystemDialog((prev) => ({ ...prev, show: false, title: '', variant: '' }));
    };
    const handleEnableFilters = () => {
        setIsFilterEnabled(true);
    };
    const DiscardAndCloseFilters = () => {
        setIsFilterEnabled(false);
        setFilters(initialFilters);
        setSystemQuery(initialQueryState);
    };
    const mapFiltersToQuery = (filters) => {
        return {
            searchTerm: filters.search || undefined,
            systemNameFilter: filters?.systemName?.trim() || undefined,
            systemTypeFilter: filters?.systemType?.trim() || undefined,
            locationFilter: filters?.lastLocation?.trim() || undefined,
            description: filters?.description?.trim() || undefined,
            lastInfoReceivedFilter: filters.lastInfoReceived
                ? convertToLocalTimezone(filters.lastInfoReceived)
                : undefined,
            assetFilter: filters?.asset?.trim() || undefined,
            statusFilter: filters.isActive?.toLowerCase() === 'active'
                ? true
                : filters.status?.toLowerCase() === 'inactive'
                    ? false
                    : undefined
        };
    };
    useEffect(() => {
        setSystemQuery((prev) => {
            const newQuery = {
                ...prev,
                ...mapFiltersToQuery(filters),
                pageNumber: prev.pageNumber || 1,
                pageSize: prev.pageSize || 10
            };
            return newQuery;
        });
    }, [filters]);
    /**
     * SINGLE useEffect for system fetching
     * - Initial mount: fetch once
     * - Query change: refetch if values actually changed
     */
    useEffect(() => {
        const queryStr = JSON.stringify(systemQuery);
        if (isInitialMountRef.current) {
            // First mount - do initial fetch
            isInitialMountRef.current = false;
            prevQueryRef.current = queryStr;
            getFilteredSystemDetail();
        }
        else if (prevQueryRef.current !== queryStr) {
            // Query changed - refetch
            prevQueryRef.current = queryStr;
            getFilteredSystemDetail();
        }
    }, [systemQuery]);
    const getFilteredSystemDetail = async () => {
        try {
            const response = await systemApi.getFilteredSystemDetail(systemQuery);
            if (response.isSuccess && response?.data) {
                setSystemDetails(response.data);
            }
        }
        catch (error) { }
    };
    return (_jsxs(React.Fragment, { children: [_jsx(PageHeader, { title: 'Systems', filters: _jsxs(_Fragment, { children: [_jsx(FiltersDiscardButton, { hasNewChanges: isFilterEnabled, handleDiscardFilters: DiscardAndCloseFilters, handleShowFilters: handleEnableFilters }), _jsx(SSearchInput, { onChange: (e) => {
                                setSystemQuery((prev) => ({
                                    ...prev,
                                    searchTerm: e.target.value
                                }));
                            } })] }) }), _jsx(SystemsDataGrid, { rows: systemDetails?.data, fullHeight: true, showFilters: isFilterEnabled, filters: filters, setFilters: setFilters, setSystemQuery: setSystemQuery, systemQuery: systemQuery, totalRows: systemDetails?.totalRecords || 0 }), systemDialog.show && (_jsx(SystemDialog, { isOpen: systemDialog.show, onClose: handleCloseSystemDialog }))] }));
};
export default Systems;
